import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { SelectionService } from '@src/slide/application/service/selection/selection-service';
import FontManager from '@src/slide/content-viewer/service/font-manager/core';
import AnimManager from '@src/slide/application/service/anim-manager';
import type { ITextEditorStateService } from '@src/slide/application/service/text-editor-state-service/text-editor-state-service.interface';
import TextEditorStateService from '@src/slide/application/service/text-editor-state-service';
import { EditorInstanceService } from '@src/slide/application/service/editor-instance-service';
import NoteAreaManager from '@src/slide/application/service/note-area-manager/note-area-manager';
import {
    ICoreViewableServiceLayer,
} from '@src/slide/content-viewer/entry/view-layer/core-viewable-service-layer.interface';
import { FontManagerInjectable } from '@src/slide/content-viewer/service/font-manager/inject/toc/font-manager-injectable';
import type { IAnimManager } from '@src/slide/application/service/anim-manager/anim-manager.interface';
import type { IFontManager } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';
import type { IEditorInstanceService } from '@src/slide/application/service/editor-instance-service/editor-instance-service.interface';
import type { INoteAreaManager } from '@src/slide/application/service/note-area-manager/note-area-manager.interface';
import {
    IEditAreaCanvasSizeManager,
} from '@src/slide/application/service/edit-area-canvas-size-manager/edit-area-canvas-size-manager.interface';
import EditAreaCanvasSizeManager from '@src/slide/application/service/edit-area-canvas-size-manager';
import { IFontManagerInjectable } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';
import { IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import {
    ICanvasRendererService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/base/canvas-renderer-service.interface';
import SlideRenderStateManager from '@src/slide/application/service/slide-render-state/slide-render-state-manager';
import {
    ISlideRenderStateManager,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

export abstract class CoreViewableServiceLayer implements ICoreViewableServiceLayer {
    public readonly contentRendererService: ICanvasRendererService;
    public readonly selectionService: ISelectionService;
    public readonly noteAreaManager: INoteAreaManager;
    public readonly fontManager: IFontManager;
    public readonly animManager: IAnimManager;
    public readonly editorInstanceService: IEditorInstanceService;
    public readonly textEditorStateService: ITextEditorStateService;
    public readonly editAreaCanvasSizeManager: IEditAreaCanvasSizeManager;
    public readonly slideRenderStateManager: ISlideRenderStateManager;

    protected infrastructureService: IInfrastructureBase;
    protected uiDataService: IUiDataService;
    public constructor(uiDataService: IUiDataService, infrastructureService: IInfrastructureBase) {
        this.infrastructureService = infrastructureService;
        this.uiDataService = uiDataService;
        this.selectionService = new SelectionService(uiDataService);
        uiDataService.setSelectionDelegate(this.selectionService);
        this.noteAreaManager = new NoteAreaManager();
        this.fontManager = new FontManager(uiDataService, this.createFontManagerInject());
        this.animManager = new AnimManager();
        this.editorInstanceService = new EditorInstanceService();
        this.editorInstanceService.setSelectionServiceDelegate(this.selectionService);
        this.textEditorStateService = new TextEditorStateService();
        this.slideRenderStateManager = new SlideRenderStateManager();
        this.slideRenderStateManager.setServicesDelegate({ uiDataService, selectionService: this.selectionService });
        this.editAreaCanvasSizeManager = new EditAreaCanvasSizeManager();
        this.contentRendererService = this.createCanvasRendererService();
    }

    protected createFontManagerInject(): IFontManagerInjectable {
        return new FontManagerInjectable();
    }

    protected abstract createCanvasRendererService(): ICanvasRendererService;
}
